import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, Subscription } from 'rxjs';
import { EmailNewOrgAdd } from 'src/app/models/Emails.model';
import { EmailType } from 'src/app/models/enums/email-type.enum';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { ManagementApiService } from 'src/app/services';
import { EmailSenderService } from 'src/app/services/email-sender.service';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/shared/info-dialogs/error-dialog/error-dialog.component';
import { InstanceUser, UserInstanceModel } from '../../../models/organization/organization.model';
import { AddUserForInstanceModalComponent } from '../../modals/organization/add-user-for-instance-modal/add-user-for-instance-modal.component';
import { ViewUserForInstanceModalComponent } from '../../modals/organization/view-user-for-instance-modal/view-user-for-instance-modal.component';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { InstanceType } from '../../../models/instance/instance.model';
import { AppConstants } from 'src/app/constants/appconstants';
import { takeUntil } from 'rxjs/operators';
import { GroupingService } from 'src/app/services/grouping.service';
import { CustomToastService } from 'src/app/services/custom-toast.service';

@Component({
    selector: 'app-instance-users',
    templateUrl: './instance-users.component.html',
    styleUrls: ['./instance-users.component.scss'],
})
export class InstanceUsersComponent implements OnInit, OnDestroy {
    users: InstanceUser[] = [];
    organizationId: any;
    selectedProfileContact: any;
    queryParamsSubscription: Subscription;
    instanceId: String;
    userdetails: any = [];
    userdetailscopy: any = [];
    div1: boolean = true;
    div2: boolean = false;
    avatarSize = 100;
    hideDeleteOption: boolean;
    hideEditOption: boolean;
    hideAddOption: boolean;
    InstanceUser: UserInstanceModel[] = [];
    tooltip_position = 'above';
    searchText: string;
    isInformateInstance: boolean;
    sentUserEmailList: any[];
    emailPayLoad: EmailNewOrgAdd;
    instanceNameSub: Subscription;
    organizationSub: Subscription;
    instanceTypeSub: Subscription;
    activeInstanceType: InstanceType;
    subscriptionList: Subscription[];
    destroy$ = new Subject();
    groupedUserdetails: Record<string, any[]> = {};

    roleKeys: string[] = [];
    isSuperAdmin: boolean = false;
    constructor(
        private managementApiService: ManagementApiService,
        private activatedRoute: ActivatedRoute,
        private ngbModal: NgbModal,
        private user_utility: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private instanceDataService: InstanceDataService,
        private emailSenderService: EmailSenderService,
        private organizationDataService: OrganizationDataService,
        private globalEmittersService: GlobalEmittersService,
        private groupingService: GroupingService,
        private customToastService: CustomToastService
    ) {
        this.isInformateInstance = false;
        this.sentUserEmailList = [];
        this.subscriptionList = [];
        this.emailPayLoad = new EmailNewOrgAdd();
        this.subscriptionList.push(this.instanceNameSub, this.organizationSub, this.instanceTypeSub);
    }

    async ngOnInit(): Promise<void> {
        this.hideDeleteOption = await this.user_utility.checkUserPermissionDataAndRoute('Instance-user', userActions.Delete);
        this.hideEditOption = await this.user_utility.checkUserPermissionDataAndRoute('Instance-user', userActions.Edit);
        this.hideAddOption = await this.user_utility.checkUserPermissionDataAndRoute('Instance-user', userActions.Create);
        this.handleSubscription();
    }

    handleSubscription() {
        this.instanceNameSub = this.instanceDataService.currentInstanceName.subscribe((res) => {
            if (res) {
                this.emailPayLoad.instanceName = res;
            }
        });

        this.organizationSub = this.organizationDataService.currentOrganizationName.subscribe((orgName: string) => {
            if (orgName) {
                this.emailPayLoad.organizationName = orgName;
            }
        });

        this.instanceDataService.isInformateInstance.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isInformateInstance = res;
        });

        this.instanceDataService.instanceActiveTab.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res == AppConstants.tab_users) {
                if (this.activatedRoute.snapshot.paramMap.get('id')) {
                    this.instanceId = this.activatedRoute.snapshot.paramMap.get('id');
                    this.getusersforinstanceallocation();

                    this.getInstanceUser(this.instanceId);
                } else {
                    this.instanceId = this.instanceDataService.instanceDetails.instanceId;
                    this.getusersforinstanceallocation();
                    this.getInstanceUser(this.instanceId);
                }
            }
        });

        this.instanceTypeSub = this.globalEmittersService.currentInstanceType.subscribe((res) => {
            if (res) {
                this.activeInstanceType = res;
            }
        });

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_users) {
                this.navigateNext();
            }
        });

        this.instanceDataService.instanceTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_users) {
                this.navigateBack();
            }
        });
    }

    openUserModal() {
        let dialogRef = this.ngbModal.open(AddUserForInstanceModalComponent, {
            size: 'md',
        });
        if (this.activeInstanceType.index == 1) {
            dialogRef.componentInstance.usersList = this.users.filter(
                (user) => user.securityRole?.toLowerCase()?.includes('informate') || !user.isDerivedFromTemplate
            );
        } else if (this.activeInstanceType.index == 2) {
            dialogRef.componentInstance.usersList = this.users.filter(
                (user) => user.securityRole.toLowerCase().includes('idms') || !user.isDerivedFromTemplate
            );
        }
        dialogRef.result
            .then((result: InstanceUser) => {
                if (result) {
                    this.selectedProfileContact = result;
                    let checkUser = this.checkUser(result.userId);
                    if (checkUser === true) {
                        let dialogRef = this.ngbModal.open(ErrorDialogComponent, {
                            size: 'sm',
                        });
                        dialogRef.componentInstance.message = 'The user is already allocated to this instance!';
                    } else {
                        let indexof = this.checkUserInstance(result.userId);
                        if (indexof == null || indexof == undefined) {
                            this.userdetails.push(result);
                            let addInstance = new UserInstanceModel();
                            addInstance.instanceId = result.instanceId;
                            addInstance.userId = result.userId;
                            this.InstanceUser.push(addInstance);
                        } else {
                            let addInstance: any = result;
                            let Instanceuserdetails: any = this.getInstanceUserData(result.userId);
                            addInstance.userInstanceId = Instanceuserdetails.userInstanceId;
                            this.userdetails.push(addInstance);
                            this.InstanceUser.splice(indexof, 1);
                        }
                        this.saveUserInstances(this.InstanceUser);
                    }
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    getusersforinstanceallocation() {
        if (!this.users?.length) {
            this.ngxUiLoaderService.start();
            this.managementApiService.getusersforinstanceallocation(this.instanceId).subscribe(
                (users) => {
                    this.ngxUiLoaderService.stop();
                    if (users.success === true && users.response.length > 0) {
                        for (let x = 0; x < users.response.length; x++) {
                            let instanceuser = new InstanceUser();
                            instanceuser.instanceId = this.instanceId;
                            instanceuser.userId = users.response[x].userId;
                            instanceuser.firstName = users.response[x].firstName;
                            instanceuser.lastName = users.response[x].lastName;
                            instanceuser.email = users.response[x].email;
                            if (users.response[x]?.securityRoles && users.response[x]?.securityRoles[0]?.securityRole.name) {
                                instanceuser.securityRole = users.response[x]?.securityRoles[0]?.securityRole.name;
                                instanceuser.isDerivedFromTemplate = users.response[x].securityRoles[0]?.securityRole?.isDerivedFromTemplate;
                                instanceuser.active = true;
                                this.users.push(instanceuser);
                            }
                        }
                    } else {
                        this.ngxUiLoaderService.stop();
                        // this.user_utility.errorModelPopup(users.message);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                }
            );
        }
    }

    getInstanceUser(instanceId) {
        // if (!this.userdetails?.length) {
        this.ngxUiLoaderService.start();
        this.managementApiService.getUserInstances(instanceId).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                this.userdetails = [];
                // if (res)
                if (res.success === true) {
                    if (res.response?.users) {
                        for (let i = 0; i < res.response.users.length; i++) {
                            let userObject = {
                                userInstanceId: res.response.users[i].userInstanceId,
                                userId: res.response.users[i].user.userId,
                                firstName: res.response.users[i].user.profileContact.firstName,
                                lastName: res.response.users[i].user.profileContact.lastName,
                                email: res.response.users[i].user?.profileContact?.email,
                                securityRole: res.response.users[i].user?.securityRoles[0]?.securityRole?.name,
                            };
                            this.userdetails.push(userObject);
                            this.userdetailscopy = this.userdetails;
                        }
                        this.groupedUserdetails = this.groupingService.groupBy(this.userdetails, 'securityRole');
                        this.roleKeys = Object.keys(this.groupedUserdetails);
                    }
                } else {
                    this.ngxUiLoaderService.stop();
                    // this.user_utility.errorModelPopup(res.message);
                }
            },
            (err) => {
                this.ngxUiLoaderService.stop();
            }
        );
        // }
    }

    div1Function() {
        this.div1 = true;
        this.avatarSize = 100;
        // this.div2 = false;
    }

    div2Function() {
        // this.div2 = true;
        this.div1 = false;
        this.avatarSize = 40;
    }

    postUserInstances(user: any) {
        this.ngxUiLoaderService.start();
        this.sentUserEmailList = this.users.filter((item) => user.find((user) => user.userId == item.userId && user?.active != false));
        // this.sentUserEmailList = this.sentUserEmailList.filter(user => user.active)
        this.managementApiService.postUserInstances(user).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success === true) {
                    this.triggerEmail(this.sentUserEmailList);
                    this.getInstanceUser(this.instanceId);
                    this.InstanceUser = [];
                    this.isInformateInstance ? this.instanceDataService.instanceNavigationHandler(2) : this.instanceDataService.instanceNavigationHandler(16);
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            },
            (err) => {
                this.ngxUiLoaderService.stop();
                let dialogRef = this.ngbModal.open(ErrorDialogComponent, {
                    size: 'sm',
                });
                dialogRef.componentInstance.message = `${err.error}`;
                this.InstanceUser = [];
            }
        );
    }

    saveUserInstances(user: any, isDelete: boolean = false) {
        this.ngxUiLoaderService.start();
        this.managementApiService.postUserInstances(user).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success === true) {
                    if (isDelete) {
                        this.customToastService.successToast('User removed from the instance.', 'Success');
                    } else {
                        this.customToastService.successToast('User assigned  to this instance.', 'Success');
                    }

                    this.getInstanceUser(this.instanceId);
                    this.InstanceUser = [];
                    //  this.isInformateInstance ? this.instanceDataService.instanceNavigationHandler(2) : this.instanceDataService.instanceNavigationHandler(16);
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            },
            (err) => {
                this.ngxUiLoaderService.stop();
                let dialogRef = this.ngbModal.open(ErrorDialogComponent, {
                    size: 'sm',
                });
                dialogRef.componentInstance.message = `${err.error}`;
                this.InstanceUser = [];
            }
        );
    }

    navigateBack() {
        if (this.isInformateInstance) {
            this.instanceDataService.instanceNavigationHandler(3);
        } else {
            this.instanceDataService.instanceNavigationHandler(17);
        }
    }

    navigateNext() {
        this.isInformateInstance ? this.instanceDataService.instanceNavigationHandler(2) : this.instanceDataService.instanceNavigationHandler(16);

        // if (this.InstanceUser.length > 0) {
        //    this.postUserInstances(this.InstanceUser);

        // } else {
        //     this.isInformateInstance ? this.instanceDataService.instanceNavigationHandler(2) : this.instanceDataService.instanceNavigationHandler(16);
        // }
    }

    clickCancel() {
        let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
            size: 'sm',
        });
        if (this.activatedRoute.snapshot.paramMap.get('id')) {
            dialogRef.componentInstance.modalMessage = 'Your changes are not saved. Are you sure you want to go back?';
        } else {
            dialogRef.componentInstance.modalMessage = 'Your Instance details are not saved. Are you sure you want to go back?';
        }
        dialogRef.result.then((result) => {
            if (result === true) {
                if (this.isInformateInstance) {
                    this.instanceDataService.navigateThroughWizard.next(0);
                } else {
                    this.instanceDataService.navigateThroughWizard.next(5);
                }
            }
        });
    }

    viewUser(user) {
        let dialogRef = this.ngbModal.open(ViewUserForInstanceModalComponent, {
            size: 'lg',
        });
        dialogRef.componentInstance.modalMode = 'View';
        dialogRef.componentInstance.instanceuser = this.findInstanceUserByUserId(user.userId);
    }

    deleteInstanceUser(user: any) {
        let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
            size: 'sm',
        });
        dialogRef.componentInstance.modalMessage = 'Are you sure you want to remove the user from this Instance?';
        dialogRef.result.then((result) => {
            if (result === true) {
                if (user.userInstanceId != null || user.userInstanceId != undefined) {
                    let userInstanceObj = new UserInstanceModel();
                    userInstanceObj.userInstanceId = user.userInstanceId;
                    userInstanceObj.active = false;
                    userInstanceObj.userId = user.userId;
                    let index = this.findIndexOfUserInstanceId(user.userInstanceId);
                    this.userdetails.splice(index, 1);
                    this.InstanceUser.push(userInstanceObj);
                } else {
                    let checkuserDetails = this.findAndReplaceUser(user.userId);
                    let index = this.checkUserInstance(user.userId);
                    this.userdetails.splice(checkuserDetails, 1);
                    this.InstanceUser.splice(index, 1);
                }
                this.saveUserInstances(this.InstanceUser, true);
            }
        });
    }

    findInstanceUserByUserId(userId: string) {
        for (let x = 0; x < this.userdetails.length; x++) {
            if (this.userdetails[x].userId == userId) {
                return this.userdetails[x];
            }
        }
    }

    findAndReplaceUser(userId) {
        for (let x = 0; x < this.userdetails.length; x++) {
            if (this.userdetails[x].userId == userId) {
                return x;
            }
        }
    }

    checkUser(userId) {
        for (let x = 0; x < this.userdetails.length; x++) {
            if (this.userdetails[x].userId == userId) {
                return true;
            }
        }
    }
    checkUserInstance(userId) {
        for (let x = 0; x < this.InstanceUser.length; x++) {
            if (this.InstanceUser[x].userId === userId) {
                return x;
            }
        }
    }

    findIndexOfUserInstanceId(userInstanceId: any) {
        for (let x = 0; x < this.userdetails.length; x++) {
            if (this.userdetails[x].userInstanceId == userInstanceId) {
                return x;
            }
        }
    }

    getInstanceUserData(userId) {
        for (let x = 0; x < this.InstanceUser.length; x++) {
            if (this.InstanceUser[x].userId == userId) {
                return this.InstanceUser[x];
            }
        }
    }

    searchResult(event: any) {
        this.userdetails = this.userdetailscopy.filter((item) => {
            return (
                (
                    (item.firstName !== undefined ? item.firstName : '').trim().toLowerCase() +
                    (item.lastName !== undefined ? item?.lastName : '').trim().toLowerCase()
                )
                    .replace(' ', '')
                    .includes(event.target.value.trim().replace(' ', '').toLowerCase()) ||
                (
                    (item.firstName !== undefined ? item.firstName : '').replace(' ', '').toLowerCase() +
                    ' ' +
                    (item.lastName !== undefined ? item?.lastName : '').replace(' ', '').toLowerCase()
                ).includes(event.target.value.trim().replace(' ', '').toLowerCase()) ||
                (
                    (item.firstName !== undefined ? item.firstName : '').toLowerCase() + (item.lastName !== undefined ? item?.lastName : '').toLowerCase()
                ).includes(event.target.value.trim().toLowerCase()) ||
                (
                    (item.firstName !== undefined ? item.firstName : '').trim().toLowerCase() +
                    (item.lastName !== undefined ? item?.lastName : '').trim().toLowerCase()
                ).includes(event.target.value.trim().replace(' ', '').toLowerCase()) ||
                ((item.firstName !== undefined ? item.firstName : '').toLowerCase() + (item.lastName !== undefined ? item?.lastName : '').toLowerCase())
                    .replace(' ', '')
                    .includes(event.target.value.replace(' ', '').toLowerCase()) ||
                (item.email !== undefined ? item.email : '').toLowerCase().includes(event.target.value.trim().replace(' ', '').toLowerCase())
            );
        });
        this.groupedUserdetails = this.groupingService.groupBy(this.userdetails, 'securityRole');
        this.roleKeys = Object.keys(this.groupedUserdetails);
    }

    // * trigger email when instance is created
    triggerEmail(userList: InstanceUser[]) {
        userList.forEach((item) => {
            this.emailPayLoad.firstName = item?.firstName ? item?.firstName : '';
            this.emailPayLoad.lastName = item?.lastName ? item?.lastName : '';
            this.emailPayLoad.email = item?.email;
            this.emailSenderService.emailHandler(EmailType.NewUserAddedIns, [item.email], this.emailPayLoad).subscribe(
                (res) => {
                    if (res) {
                        // TODO Email sent successfully
                    }
                },
                (err) => {
                    // TODO Email failed
                }
            );
        });
    }

    // * helper method for controlling hover effect css dynamically
    manageHover(index: number) {
        let element = document.getElementById('kt_body').lastChild as HTMLElement;
        switch (index) {
            case 0:
                element.classList.add('hover-custom');
                break;
            case 1:
                element.classList.remove('hover-custom');
                break;
        }
    }

    // * check text oveflow
    checkIsTextOverflow(hoverProperty: string, elementId: string): boolean {
        let element;
        switch (hoverProperty) {
            case 'firstName':
                element = document.getElementById(`${elementId}-first-name`);
                break;

            case 'lastName':
                element = document.getElementById(`${elementId}-last-name`);
                break;

            case 'email':
                element = document.getElementById(`${elementId}-email`);
                break;

            case 'role':
                element = document.getElementById(`${elementId}-role`);
                break;
        }

        if (element) {
            return element.scrollWidth > element.offsetWidth;
        } else {
            return false;
        }
    }

    ngOnDestroy(): void {
        this.subscriptionList.forEach((sub) => {
            if (sub) {
                sub.unsubscribe();
            }
        });

        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
